import React from "react";
import { Field } from "formik";

import { Input as ChakraInput, Text } from "@chakra-ui/core";
import { EditorTheme } from "../../theme";

export const Input = (props) => (
    <>
        {props?.label?.length > 0 && props?.type !== "hidden" && (
            <>
                <Text mb="8px" fontWeight={600}>
                    {props.label}
                    {props.required && (
                        <Text as="sup" color="brand.orange">
                            *
                        </Text>
                    )}
                </Text>
            </>
        )}

        <Field name={props.name}>
            {({ field, form }) => (
                <ChakraInput
                    borderColor={
                        field.value?.length > 0 ? "brand.white" : "brand.grey"
                    }
                    color={
                        field.value?.length > 0 ? "brand.white" : "brand.grey"
                    }
                    _hover={{ borderColor: `brand.white` }}
                    _placeholder={{ color: "brand.lightGrey" }}
                    height="45px"
                    fontSize={`14px`}
                    borderRadius={0}
                    backgroundColor="brand.black"
                    _focus={{
                        borderColor: `brand.orange`,
                        boxShadow: `0 0 0 1px ${EditorTheme.colors.brand.orange}`,
                    }}
                    mb={
                        props.help
                            ? `5px`
                            : {
                                  base: `15px`,
                                  md: `30px`,
                              }
                    }
                    aria-label={props.label}
                    onChange={(e) =>
                        form.setFieldValue(field.name, e.target.value)
                    }
                    isDisabled={form.isSubmitting || props.disabled}
                    {...props}
                />
            )}
        </Field>

        {props?.help?.length > 0 && props?.type !== "hidden" && (
            <Text
                color="brand.lightGrey"
                fontSize="sm"
                mb={{
                    base: `15px`,
                    md: `30px`,
                }}
            >
                {props.help}
            </Text>
        )}
    </>
);
